import { useState } from "react";
import styled from "@emotion/styled";

import EditRounded from "@mui/icons-material/EditRounded";
import AppRegistrationRoundedIcon from '@mui/icons-material/AppRegistrationRounded';

import Dialog from "../../../utils/utilities/Dialog";

import { BasicFlex, LabelUpper } from "../../../utils/Common";

import { IconButton, Tooltip, Divider } from "@mui/material";

import RepairTask from "./RepairTask";

import DraggableComponent from "../../../utils/utilities/Draggable";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { editRepair } from "../apiService";

const Label = styled(LabelUpper)`
  margin-bottom: 1rem;
`

const Container = styled.div`
  padding: 1.6rem;
`

const EditTasks = ({ ticket, dash = false }) => {

  const [list, setList] = useState([]);

  let non_editable_repairs = ticket?.repairs?.filter((repair) => repair?.status !== "scheduled") || [];
  let scheduled_repairs = ticket?.repairs?.filter((repair) => repair?.status === "scheduled") || [];

  console.log(ticket, "repairs");

  const queryClient = useQueryClient();
  
  let qk = ['repair_tickets']
  if (!dash) {
    qk.push(ticket?.repair_ticket_id);
  }

  const { mutateAsync } = useMutation({
    mutationFn: editRepair,
    onSuccess: () => {
      console.log("success");
      queryClient.invalidateQueries({ queryKey: qk });
      // setList([]);
    }
  });

  const submitEdits = async () => {
    console.log("list", list);
    let dataPacket = {
      ...ticket,
      repairs: non_editable_repairs.concat(list)
    }
    
    await mutateAsync({repair_ticket_id: ticket?.repair_ticket_id, dataPacket});
  }

  return (
    <Dialog
      title="Edit Task Order"
      toggle={
        <Tooltip title="Modify Task Order"><IconButton size="small" color="secondary"><AppRegistrationRoundedIcon /></IconButton></Tooltip>
      }
      size="lg"
      saveText="Update Task Order"
      saveFunc={submitEdits}
    >
      <Container>
        <LabelUpper $normal $size="1.2rem">Completed Repairs</LabelUpper>
        <BasicFlex my="1rem" dir="column" gap="1rem">
          {non_editable_repairs.map((repair) => <RepairTask key={repair.repair_id} repair={repair} />)}
        </BasicFlex>

        <Divider sx={{my: "2rem"}} />

        <Label $normal>Scheduled Repairs</Label>
        <DraggableComponent fieldName="scheduled_repairs" list={scheduled_repairs} render={(repair) => <RepairTask key={repair.repair_id} repair={repair} />} setOrderedList={setList} />
      </Container>
    </Dialog>
  )

};

export default EditTasks;